import { ITranslation } from '../common/io/translation';
import { ReactElement } from 'react';
import { Trans } from 'react-i18next';
import { getLanguageId } from '../common/function/utilities';

export function getTranslationByLanguage(input: ITranslation[]): ITranslation {
	return _translate(input);
}

export function translateName(input: ITranslation[]): string {
    return _translate(input)?.name ?? '';
}

export function translateSubtitle(input: ITranslation[]): string {
    return _translate(input)?.subtitle ?? '';
}

export function translateUrl(input: ITranslation[]): string {
    return _translate(input)?.url ?? '';
}

export function translateTitle(input: ITranslation[]): string {
    return _translate(input)?.title ?? '';
}

export function translateValue(input: ITranslation[]): string {
    return _translate(input)?.value ?? '';
}

export function translateDescription(input: ITranslation[]): string {
    return _translate(input)?.description ?? '';
}

export function translateHobby(input: ITranslation[]): string {
    return _translate(input)?.aiHobby ?? '';
}

export function translateMotivational(input: ITranslation[]): string {
    return _translate(input)?.aiMotivational ?? '';
}

export function translateSoftSkills(input: ITranslation[]): string {
    return _translate(input)?.aiSoftSkills ?? '';
}

export function translateCvSummary(input: ITranslation[]): string {
    return _translate(input)?.aiCv ?? '';
}

export function translateSport(input: ITranslation[]): string {
	return _translate(input)?.aiSport ?? '';
}

export function translateVolunteer(input: ITranslation[]): string {
    return _translate(input)?.aiVolunteer ?? '';
}

function _translate(input: ITranslation[]): ITranslation {
	let lang: number = getLanguageId() ?? 1;
    let out: ITranslation[] = input.filter((e: ITranslation): boolean => e.idLanguage === lang);
    if (out.length > 0) {
        return out[0];
    }
    return input[0];
}

export function render(key: string, radiusTop?: boolean, radiusBottom?: boolean): ReactElement {
	return (
		<Trans
			i18nKey={key}
			components={{
				small: <small />,
				strong: <strong />,
				italic: <i />,
				iframe: (
					<iframe
						loading='lazy'
						width='100%'
						style={{
							maxWidth: '100%',
							height: 'auto',
							border: 'none',
							borderTopLeftRadius: radiusTop ? '.75rem' : undefined,
							borderTopRightRadius: radiusTop ? '.75rem' : undefined,
							borderBottomLeftRadius: radiusBottom ? '.75rem' : undefined,
							borderBottomRightRadius: radiusBottom ? '.75rem' : undefined,
						}}
					/>
				),
			}}
		/>
	);
}
